// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Votre boutique sur un téléphone',
    desktop: 'Votre boutique sur un ordinateur',
  },
  loading: "Chargement de la capture d'écran",
  failed: "La capture d'écran n'a pas pu être chargée.",
};
